import React, { useEffect, useRef, useState } from "react";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { Button, Modal, Form } from "react-bootstrap";
import { BsPlusCircle, BsTrash, BsPencil } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ConfirmationAlert, getOnlyToken } from "../utils/commonFunctions";
import axios from "axios";
import Loader from "../Components/Loader";


export default function CreateIVR() {
  const navigate = useNavigate();
  const [audioList, setAudioList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [agents, setAgents] = useState([])
  const [showIvrEntities, setShowIvrEntities] = useState(false);
  const [createdIvrData, setCreatedIvrData] = useState(null);
  const [companies,setCompanies]= useState([])
  const [parentcompany,setParentCompany]= useState()
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('text');
  const [agentsLoaded, setAgentsLoaded] = useState(false);
const [ivrLoaded, setIvrLoaded] = useState(false);

  

  const { company_id, editMode, ivrID } = location.state || {};

  console.log('Company ID:', company_id);
  console.log('Edit Mode:', editMode);
  console.log('IVR ID:', ivrID);


  // Form 1: IVR Configuration Form
 const {
  register: registerIvr,
  control: controlIvr,
  handleSubmit: handleSubmitIvr,
  reset: resetIvr,
  watch: watchIvr,
  formState: { errors: errorsIvr },
} = useForm({ shouldUnregister: false });


  
  // Form 2: Speech IVR Form
  const {
    register: registerSpeech,
    handleSubmit: handleSubmitSpeech,
    reset: resetSpeech,
    watch: watchSpeech,
    formState: { errors: errorsSpeech },
  } = useForm({ shouldUnregister: false });

  // Form 3: IVR Entries Form
  const {
  register: registerEntry,
  control: controlEntry,
  handleSubmit: handleSubmitEntry,
  reset: resetEntry,
  watch: watchEntry,
  formState: { errors: errorsEntry },
} = useForm({
  shouldUnregister: false,
  defaultValues: {
    ivrEntries: [
      {
        ivrNumber: "",
        destinationType: "",
        destination: "",
        returnToIvr: false,
      },
    ],
  },
});


  const token = getOnlyToken();

  const timeoutDestinationType = useWatch({ control: controlIvr, name: "timeoutDestinationType" });
  const invalidDestinationType = useWatch({ control: controlIvr, name: "invalidDestinationType" });

  useEffect(() => {
  console.log("EDIT MODE VALUES:", watchIvr());
}, [watchIvr()]);


  // useEffect(() => {
  //   if (!editMode) {
  //     setValueIvr("timeoutDestination", "");
  //   }
  // }, [timeoutDestinationType, setValueIvr, editMode]);

  // useEffect(() => {
  //   if (!editMode) {
  //     setValueIvr("invalidDestination", "");
  //   }
  // }, [invalidDestinationType, setValueIvr, editMode]);

  


  useEffect(() => {
    fetchAudios()
    fetchAgents()
    fetchCompanies()
    fetchIVR(company_id)
    // if (editMode && ivrID) {
    //   fetchIvrDetails(ivrID);
    //   setShowIvrEntities(true);
    // }
  }, [company_id, editMode, ivrID])

  useEffect(() => {
  if (editMode && ivrID && agentsLoaded && ivrLoaded) {
    fetchIvrDetails(ivrID);
  }
}, [editMode, ivrID, agentsLoaded, ivrLoaded]);


  const fetchCompanies = async ()=>{
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get('api/agents/folder/create/',config)
      if(res.status === 200){
        setCompanies(res.data.folders)
      }
    } catch (error) {
      console.error('Failed to fetch agents for folder', error);
      setCompanies([]);
    }
  }


 

  const fetchAgents = async () => {
    try {
      setLoading(true)
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const response = await axios.get(`api/agents/agent-dropdown/?agent_type=in-bound`, config);
      if (response.status === 200) {
        // assume agents returned in response.data.agents or response.data.data
        const agents = response.data || [];
        setAgents(agents);
         setAgentsLoaded(true);
      } else {
        setAgents([]);
      }
    } catch (error) {
      console.error('Failed to fetch agents for folder', error);
      setAgents([]);
       setAgentsLoaded(true);
    } finally {
      setLoading(false);
    }
  }


  const [Ivrdata, setIvrData] = useState([])
  const fetchIVR = async (id) => {
    try {

      const config = { headers: { Authorization: `Bearer ${token}` } };

      const res = await axios.get(`/ivr/ivr-config/dropdown/`, config)

      if (res.status === 200) {
        setIvrData(res.data)
         setIvrLoaded(true);
      }
    } catch (error) {
      console.log(error, 'errror')
       setIvrLoaded(true);
    }
  }
  const capitalize = (val = "") =>
  val ? val.charAt(0).toUpperCase() + val.slice(1) : "";


const fetchIvrDetails = async (id) => {
  try {
    setLoading(true);

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`/ivr/ivr-config/${id}/`, config);

    if (res.status === 200) {
      const d = res.data;

      setParentCompany(d.company);

      if(res.data.greeting_type === "speech"){
        console.log('speech mode')
         setActiveTab("speech")
         resetSpeech({
           speechIvrName: d.ivr_name ?? "",
           speechAgent: d.speech_agent != null ? d.speech_agent : "",
           speechDescription: d.ivr_description ?? "",
         });
      }else{
 resetIvr(
        {
          ivrName: d.ivr_name ?? "",
          ivrDescription: d.ivr_description ?? "",
          ivrAudio: d.greeting_audio_path ?? "",

          timeoutRetries:
            d.timeout_retries != null ? d.timeout_retries : "",
          ringTimeout:
            d.ring_timeout_seconds != null
              ? d.ring_timeout_seconds
              : "",

          timeoutDestinationType: capitalize(d.timeout_destination_type),
          timeoutDestination: d.timeout_destination_agent
            ? d.timeout_destination_agent
            : d.timeout_destination_ivr
            ? d.timeout_destination_ivr
            : "",

          timeoutRetriesAudio: d.timeout_retries_audio ?? "",
          noinputtimeout:
            d.no_input_timeout != null
              ? d.no_input_timeout
              : "",

          invalidretries:
            d.invalid_retries != null ? d.invalid_retries : "",
          invalidRetryAudio: d.invalid_retry_audio ?? "",
          invalidFinalAudio: d.invalid_final_audio ?? "",

          invalidDestinationType: capitalize(d.invalid_destination_type),
          invalidDestination: d.invalid_destination_agent
            ? d.invalid_destination_agent
            : d.invalid_destination_ivr
            ? d.invalid_destination_ivr
            : "",
        },
        {
          keepDirty: false,
          keepTouched: false,
        }
      );
      }

     

      setCreatedIvrData(d);
      setShowIvrEntities(true);

      /* ---------------------------
         IVR ENTRIES (FieldArray)
      ---------------------------- */
      if (Array.isArray(d.ivr_entries) && d.ivr_entries.length > 0) {
        resetEntry({
          ivrEntries: d.ivr_entries.map((e) => ({
            id: e.id,
            ivrNumber: String(e.entry_number),

            destinationType: capitalize(e.destination_type),

            destination: e.destination_agent
              ? e.destination_agent
              : e.destination_ivr
              ? e.destination_ivr
              : "",

            returnToIvr: e.return_to_ivr === true ? 1 : 0,
          })),
        });
      } else {
        resetEntry({
          ivrEntries: [
            {
              ivrNumber: "",
              destinationType: "",
              destination: "",
              returnToIvr: false,
            },
          ],
        });
      }
    }
  } catch (error) {
    console.error("Error fetching IVR details:", error);
  } finally {
    setLoading(false);
  }
};


console.log("AFTER RESET:", watchIvr());


  const fetchAudios = async () => {
    try {
      setLoading(true);

      const config = { headers: { Authorization: `Bearer ${token}` } };

      const res = await axios.get(`ivr/ivr-audios/`, config)

      if (res.status === 200) {
        setAudioList(res.data)
        console.log(res.data, 'audiolist');

      }
    } catch (error) {
      console.log(error, 'errror')
    } finally {
      setLoading(false);

    }
  }

 

  const { fields, append, remove } = useFieldArray({
    control: controlEntry,
    name: "ivrEntries",
  });

  const handleSpeechCreate = handleSubmitSpeech(async (data) => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const payload = {
        ivr_name: data.speechIvrName,
        ivr_description: data.speechDescription || "",
        greeting_type: "speech",
        agent_id: parseInt(data.speechAgent),
      };

      if (editMode && ivrID) {
        const res = await axios.put(`/ivr/ivr_config/${ivrID}/update/`, payload, config);
        if (res.status === 200 || res.status === 201) {
          setSuccessMessage('IVR configuration updated successfully!');
          setShowSuccessModal(true);
          navigate('/ivr');
        }
      } else {
        const res = await axios.post('/ivr/ivr_config/create/', payload, config);
        if (res.status === 201 || res.status === 200) {
          setSuccessMessage('Speech IVR created successfully!');
          setShowSuccessModal(true);
          navigate('/ivr');
        }
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to save Speech IVR');
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  });

  const handleIvrCreate = handleSubmitIvr(async (data) => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const payload = {
        // company: data.company,
        ivr_name: data.ivrName,
        greeting_type: "text",
        ivr_description: data.ivrDescription || "",
        greeting_audio_file_name: data.ivrAudio,
        timeout_retries_audio: data.timeoutRetriesAudio,
        timeout_destination_type: data.timeoutDestinationType.toLowerCase(),
        timeout_destination_agent: data.timeoutDestinationType === "Agent" ? parseInt(data.timeoutDestination) : null,
        timeout_destination_ivr: data.timeoutDestinationType === "Ivr" ? parseInt(data.timeoutDestination) : null,
        timeout_retries: parseInt(data.timeoutRetries),
        invalid_destination_type: data.invalidDestinationType.toLowerCase(),
        invalid_destination_agent: data.invalidDestinationType === "Agent" ? parseInt(data.invalidDestination) : null,
        invalid_destination_ivr: data.invalidDestinationType === "Ivr" ? parseInt(data.invalidDestination) : null,
        invalid_retries: parseInt(data.invalidretries),
        no_input_timeout: parseInt(data.noinputtimeout),
        invalid_retry_audio: data.invalidRetryAudio,
        invalid_final_audio: data.invalidFinalAudio,
        ring_timeout_seconds: parseInt(data.ringTimeout)
      };


      if (editMode && ivrID) {
        const res = await axios.put(`/ivr/ivr_config/${ivrID}/update/`, payload, config);
        if (res.status === 200 || res.status === 201) {
          setSuccessMessage('IVR configuration updated successfully!');
        setShowSuccessModal(true);
        navigate('/ivr')
        }
        
      } else {
        const res = await axios.post('/ivr/ivr_config/create/', payload, config);
        if(res.status === 201 || res.status === 200){
          setParentCompany(res.data.data.external_api_response.companyId)
          setCreatedIvrData(res.data.data);
          setShowIvrEntities(true);
          setSuccessMessage('IVR created successfully! You can now add IVR entries.');
          setShowSuccessModal(true);
        }
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to save IVR');
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }, (errors) => {
    console.log('Form validation errors:', errors);
  });

  console.log(createdIvrData, 'dafafa')

  const handleIvrEntitiesSave = handleSubmitEntry(async (data) => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const entries = data.ivrEntries.map(entry => {
        const entryData = {
          entry_number: parseInt(entry.ivrNumber),
          destination_type: entry.destinationType?.toLowerCase(),
          return_to_ivr: entry.returnToIvr ? 1 : 0
        };

        if (entry.id) {
          entryData.id = entry.id;
        }

        if (entry.destinationType === "Agent" && entry.destination) {
          entryData.destination_agent = parseInt(entry.destination);
        }
        if (entry.destinationType === "Ivr" && entry.destination) {
          entryData.destination_ivr = parseInt(entry.destination);
        }

        return entryData;
      });

      const payload = {
        parent_ivr: createdIvrData.id,
        companyId: parentcompany,
        entries
      };
        await axios.post(`/ivr/ivr-entries/sync/`,payload,config)

        await fetchIvrDetails(ivrID)

      setSuccessMessage('IVR entries saved successfully!');
      setShowSuccessModal(true);
      if(!editMode){
       navigate("/ivr")
      }
    } catch (error) {
      console.error('Error saving IVR entries:', error);
      setErrorMessage(error.response?.data?.message || 'Failed to save IVR entries');
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  });


  const deleteIvrentry = (index) => {
    const entryId = watchEntry(`ivrEntries.${index}.id`);
    if (!entryId) {
      remove(index);
      return;
    }
    ConfirmationAlert(
      `You won't be able to revert this IVR entry!`,
      'Yes, delete it!',
      () => handleDeleteIvrEntry(entryId)
    );
  }

  const handleDeleteIvrEntry = async (entryId) => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`/ivr/ivr-entries/${entryId}/delete/`, config);
      await fetchIvrDetails(ivrID);
      setSuccessMessage('IVR entry deleted successfully!');
      setShowSuccessModal(true);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to delete IVR entry');
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className="container-fluid py-2">
      {loading && (
        <div className="full-page-loader-overlay">
          <Loader />
        </div>
      )}
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold text-success">IVR Creation</h3>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => navigate("/ivr")}
        >
          <i className="bi bi-arrow-left me-1"></i> Back
        </button>
      </div>

  
        <div className="card shadow-sm">
          <div className="card-body">
               <div className="d-flex justify-content-between mb-3">
                <div>
                  <h3 className="text-white " >{activeTab === 'text' ? "IVR" : "Speech IVR" }</h3 >
                </div>
        <div
          className="d-flex align-items-center p-1  rounded-pill"
          style={{
            background: "#0f0f0f",
            border: "1px solid #3f3f3f",
            gap: "4px",
          }}
        >
          <button
            className={`btn rounded-pill px-4 ${activeTab === "text" ? "btn-success" : ""
              }`}
            onClick={() => setActiveTab("text")}
            disabled={loading}
          >
            Text
          </button>

          <button
            className={`btn rounded-pill px-4 ${activeTab === "speech" ? "btn-success" : ""
              }`}
            onClick={() => setActiveTab("speech")}
            disabled={loading}
          >
            Speech
          </button>
        </div>
      </div>
            {activeTab === "text" &&
            <>
            <div className="row g-3">
             

              <div className="col-md-3">
                <label className="form-label fw-semibold">
                  IVR Name *
                </label>
                <input
                  className={`form-control ${errorsIvr.ivrName ? 'is-invalid' : ''}`}
                  {...registerIvr("ivrName", { required: "IVR Name is required" })}
                />
                {errorsIvr.ivrName && <div className="invalid-feedback d-block">{errorsIvr.ivrName.message}</div>}
              </div>
               {/* <div className="col-md-3">
                <label className="form-label fw-semibold">
                  Company *
                </label>
                <select
                  className={`form-select ${errorsIvr.company ? 'is-invalid' : ''}`}
                  {...registerIvr("company", { required: "Company is required" })}
                >
                  <option value="">-- Select Company --</option>
                  {companies.map((comp) => (
                    <option key={comp.id} value={comp.id}>
                      {comp.folder_data?.company_name || comp.folder_name}
                    </option>
                  ))}
                </select>
                {errorsIvr.company && <div className="invalid-feedback d-block">{errorsIvr.company.message}</div>}
              </div> */}

              <div className="col-md-3 ">
                <label className="form-label fw-semibold">
                  Select Audio *
                </label>
                <div className="d-flex align-items-center">
                        <select
                  className={`form-select ${errorsIvr.ivrAudio ? 'is-invalid' : ''}`}
                  {...registerIvr("ivrAudio", { required: "Audio is required" })}
                >
                  <option value="">-- -- Select Audio -- --</option>
            
                  {audioList.map((a, i) => (
                    <option key={i} value={a.filename}>
                      {a.filename}
                    </option>
                  ))}
                </select>
                {audioList.length <= 0 && (
                    <button
                      type="button"
                      className="btn btn-success btn-sm rounded-circle ms-1 d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px" }}
                    onClick={() =>
                      navigate("/ivr", {
                        state: { openModal: true }
                      })
                    }
                    >
                      <i className="bi bi-plus fs-4 fw-bold"></i>
                    </button>
                )}
                </div>
                {errorsIvr.ivrAudio && <div className="invalid-feedback d-block">{errorsIvr.ivrAudio.message}</div>}
              </div>

              <div className="col-md-3">
                <label className="form-label">Timeout Retries *</label>
                <input
                  className={`form-control ${errorsIvr.timeoutRetries ? 'is-invalid' : ''}`}
                  type="number"
                  {...registerIvr("timeoutRetries", { required: "Timeout Retries is required" })}
                />
                {errorsIvr.timeoutRetries && <div className="invalid-feedback d-block">{errorsIvr.timeoutRetries.message}</div>}
              </div>
                <div className="col-md-3">
                <label className="form-label">Ring Timeout (seconds) *</label>
                <input
                  className={`form-control ${errorsIvr.ringTimeout ? 'is-invalid' : ''}`}
                  type="number"
                  {...registerIvr("ringTimeout", { required: "Ring Timeout is required" })}
                />
                {errorsIvr.ringTimeout && <div className="invalid-feedback d-block">{errorsIvr.ringTimeout.message}</div>}
              </div>
              
            </div>

            <div className="row g-3 mt-2">
            
              <div className="col-md-3">
                <label className="form-label">Timeout Destination *</label>
                <select
                  className={`form-select ${errorsIvr.timeoutDestinationType ? 'is-invalid' : ''}`}
                  {...registerIvr("timeoutDestinationType", { required: "Timeout Destination Type is required" })}
                >
                  <option value="">Select</option>
                  <option value="Agent">Agent</option>
                  <option value="Ivr">IVR</option>
                </select>
                {errorsIvr.timeoutDestinationType && <div className="invalid-feedback d-block">{errorsIvr.timeoutDestinationType.message}</div>}
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  {timeoutDestinationType ? `Select ${timeoutDestinationType}` : "Destination"} *
                </label>
                <select
                  key={`timeout-${timeoutDestinationType}`}
                  className={`form-select ${errorsIvr.timeoutDestination ? 'is-invalid' : ''}`}
                  disabled={!timeoutDestinationType}
                  {...registerIvr("timeoutDestination", { required: "Destination is required" })}
                >
                  <option value="">
                    {timeoutDestinationType ? `Select ${timeoutDestinationType}` : "Select Destination"}
                  </option>
                  {timeoutDestinationType === "Agent" &&
                    agents.map((agent) => (
                      <option key={agent.agent_id} value={agent.agent_id}>
                        {agent.agent_name}
                      </option>
                    ))}
                  {timeoutDestinationType === "Ivr" &&
                    Ivrdata.map((ivr) => (
                      <option key={ivr.id} value={ivr.id}>
                        {ivr.ivr_name}
                      </option>
                    ))}
                </select>
                {errorsIvr.timeoutDestination && <div className="invalid-feedback d-block">{errorsIvr.timeoutDestination.message}</div>}
              </div>

              <div className="col-md-3">
                <label className="form-label">Timeout Retries Audio *</label>
                <select
                  className={`form-select ${errorsIvr.timeoutRetriesAudio ? 'is-invalid' : ''}`}
                  {...registerIvr("timeoutRetriesAudio", { required: "Timeout Retries Audio is required" })}
                >
                  <option value="">-- Select Audio --</option>
                  {audioList.map((a, i) => (
                    <option key={i} value={a.filename}>
                      {a.filename}
                    </option>
                  ))}
                </select>
                {errorsIvr.timeoutRetriesAudio && <div className="invalid-feedback d-block">{errorsIvr.timeoutRetriesAudio.message}</div>}
              </div>

             <div className="col-md-3">
                <label className="form-label">No Input Timeout *</label>
                <input
                  className={`form-control ${errorsIvr.noinputtimeout ? 'is-invalid' : ''}`}
                  type="number"
                  {...registerIvr("noinputtimeout", { required: "No Input Timeout is required" })}
                />
                {errorsIvr.noinputtimeout && <div className="invalid-feedback d-block">{errorsIvr.noinputtimeout.message}</div>}
              </div>
            </div>

            <div className="row g-3 mt-2">
               
              <div className="col-md-3">
                <label className="form-label">Invalid Retries *</label>
                <input
                  className={`form-control ${errorsIvr.invalidretries ? 'is-invalid' : ''}`}
                  type="number"
                  {...registerIvr("invalidretries", { required: "Invalid Retries is required" })}
                />
                {errorsIvr.invalidretries && <div className="invalid-feedback d-block">{errorsIvr.invalidretries.message}</div>}
              </div>

              <div className="col-md-3">
                <label className="form-label">Invalid Retry Audio *</label>
                <select
                  className={`form-select ${errorsIvr.invalidRetryAudio ? 'is-invalid' : ''}`}
                  {...registerIvr("invalidRetryAudio", { required: "Invalid Retry Audio is required" })}
                >
                  <option value="">-- Select Audio --</option>
                  {audioList.map((a, i) => (
                    <option key={i} value={a.filename}>
                      {a.filename}
                    </option>
                  ))}
                </select>
                {errorsIvr.invalidRetryAudio && <div className="invalid-feedback d-block">{errorsIvr.invalidRetryAudio.message}</div>}
              </div>

              <div className="col-md-3">
                <label className="form-label">Invalid Final Audio *</label>
                <select
                  className={`form-select ${errorsIvr.invalidFinalAudio ? 'is-invalid' : ''}`}
                  {...registerIvr("invalidFinalAudio", { required: "Invalid Final Audio is required" })}
                >
                  <option value="">-- Select Audio --</option>
                  {audioList.map((a, i) => (
                    <option key={i} value={a.filename}>
                      {a.filename}
                    </option>
                  ))}
                </select>
                {errorsIvr.invalidFinalAudio && <div className="invalid-feedback d-block">{errorsIvr.invalidFinalAudio.message}</div>}
              </div>
              <div className="col-md-3">
                <label className="form-label">Invalid Destination *</label>
                <select
                  className={`form-select ${errorsIvr.invalidDestinationType ? 'is-invalid' : ''}`}
                  {...registerIvr("invalidDestinationType", { required: "Invalid Destination Type is required" })}
                >
                  <option value="">Select</option>
                  <option value="Agent">Agent</option>
                  <option value="Ivr">IVR</option>
                </select>
                {errorsIvr.invalidDestinationType && <div className="invalid-feedback d-block">{errorsIvr.invalidDestinationType.message}</div>}
              </div>
            </div>

            <div className="row g-3 mt-2">
                
              <div className="col-md-3">
                <label className="form-label">
                  {invalidDestinationType ? `Select ${invalidDestinationType}` : "Destination"} *
                </label>
                <select
                  key={`invalid-${invalidDestinationType}`}
                  className={`form-select ${errorsIvr.invalidDestination ? 'is-invalid' : ''}`}
                  disabled={!invalidDestinationType}
                  {...registerIvr("invalidDestination", { required: "Destination is required" })}
                >
                  <option value="">
                    {invalidDestinationType ? `Select ${invalidDestinationType}` : "Select Destination"}
                  </option>
                  {invalidDestinationType === "Agent" &&
                    agents.map((agent) => (
                      <option key={agent.agent_id} value={agent.agent_id}>
                        {agent.agent_name}
                      </option>
                    ))}
                  {invalidDestinationType === "Ivr" &&
                    Ivrdata.map((ivr) => (
                      <option key={ivr.id} value={ivr.id}>
                        {ivr.ivr_name}
                      </option>
                    ))}
                </select>
                {errorsIvr.invalidDestination && <div className="invalid-feedback d-block">{errorsIvr.invalidDestination.message}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">IVR Description</label>
                <textarea
                  rows={3}
                  className="form-control"
                  {...registerIvr("ivrDescription")}
                />
              </div>
            </div>

            {showIvrEntities && (
              <div className="border rounded p-3 mt-4 bg-black">
                <div className="d-flex justify-content-between mb-2">
                  <h6 className="fw-bold">IVR Entries</h6>
                  <BsPlusCircle
                    size={22}
                    className="text-success cursor-pointer"
                    onClick={() =>
                      append({
                        ivrNumber: "",
                        destinationType: "",
                        destination: "",
                        returnToIvr: false,
                      })
                    }
                  />
                </div>

                {fields.map((field, index) => {
                  const entryDestinationType = watchEntry(`ivrEntries.${index}.destinationType`);
                  return (
                    <div className="row g-3 mb-2 align-items-center" key={field.id}>
                      <input type="hidden" {...registerEntry(`ivrEntries.${index}.id`)} />
                      <div className="col-auto">
                        <span className="fw-bold">{index + 1}</span>
                      </div>

                      <div className="col-md-2">
                        <input
                          className={`form-control ${errorsEntry.ivrEntries?.[index]?.ivrNumber ? 'is-invalid' : ''}`}
                          placeholder="Key (e.g., 1)"
                          {...registerEntry(`ivrEntries.${index}.ivrNumber`, {
                            required: "Key is required",
                            pattern: {
                              value: /^[0-9]+$/,
                              message: "Only numbers allowed"
                            }
                          })}
                        />
                        {errorsEntry.ivrEntries?.[index]?.ivrNumber && (
                          <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].ivrNumber.message}</div>
                        )}
                      </div>

                      <div className="col-md-2">
                        <select
                          className={`form-select ${errorsEntry.ivrEntries?.[index]?.destinationType ? 'is-invalid' : ''}`}
                          {...registerEntry(`ivrEntries.${index}.destinationType`, { required: "Type is required" })}
                        >
                          <option value="">Select Type</option>
                          <option value="Agent">Agent</option>
                          <option value="Ivr">IVR</option>
                        </select>
                        {errorsEntry.ivrEntries?.[index]?.destinationType && (
                          <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].destinationType.message}</div>
                        )}
                      </div>

                      <div className="col-md-3">
                        <select
                        key={`entry-${index}-${entryDestinationType}`}
                          className={`form-select ${errorsEntry.ivrEntries?.[index]?.destination ? 'is-invalid' : ''}`}
                          disabled={!entryDestinationType}
                          {...registerEntry(`ivrEntries.${index}.destination`, { required: "Destination is required" })}
                        >
                          <option value="">
                            {entryDestinationType ? `Select ${entryDestinationType}` : "Select Destination"}
                          </option>
                          {entryDestinationType === "Agent" &&
                            agents.map((agent) => (
                              <option key={agent.agent_id} value={agent.agent_id}>
                                {agent.agent_name}
                              </option>
                            ))}
                          {entryDestinationType === "Ivr" &&
                            Ivrdata.map((ivr) => (
                              <option key={ivr.id} value={ivr.id}>
                                {ivr.ivr_name}
                              </option>
                            ))}
                        </select>
                        {errorsEntry.ivrEntries?.[index]?.destination && (
                          <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].destination.message}</div>
                        )}
                      </div>

                      <div className="col-md-2">
                        <input
                          type="checkbox"
                          className="me-2"
                          {...registerEntry(`ivrEntries.${index}.returnToIvr`)}
                        />
                        Return to IVR
                      </div>

                      <div className="col-auto">
                        <BsTrash
                          size={18}
                          className="text-danger cursor-pointer"
                          title="Delete"
                          onClick={() => deleteIvrentry(index)}
                        />
                      </div>
                    </div>
                  );
                })}

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleIvrEntitiesSave}
                  >
                    <i className="bi bi-save me-1"></i> {editMode ? 'Update Entries' : 'Save Entries'}
                  </button>
                </div>
              </div>
            )}

             <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/ivr")}
                hidden={!editMode && showIvrEntities}
              >
                <i className="bi bi-x-circle me-1"></i> Cancel
              </button>
              {editMode ? (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    console.log('Update IVR Configuration button clicked');
                    handleIvrCreate(e);
                  }}
                >
                  <i className="bi bi-check-circle me-1"></i> Update IVR Configuration
                </button>
              ) : (
                !showIvrEntities ? (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleIvrCreate}
                  >
                    <i className="bi bi-check-circle me-1"></i> Save IVR
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={()=>navigate("/ivr")}
                    >
                      <i className="bi bi-skip-forward me-1"></i> Skip for Now
                    </button>
                  </>
                )
              )}
            </div>
            </>}

            {activeTab === 'speech' &&
            <>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label fw-semibold">IVR Name *</label>
                <input
                  className={`form-control ${errorsSpeech.speechIvrName ? 'is-invalid' : ''}`}
                  placeholder="Enter IVR Name"
                  {...registerSpeech("speechIvrName", { required: "IVR Name is required" })}
                />
                {errorsSpeech.speechIvrName && <div className="invalid-feedback d-block">{errorsSpeech.speechIvrName.message}</div>}
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Agent *</label>
                <select
                  className={`form-select ${errorsSpeech.speechAgent ? 'is-invalid' : ''}`}
                  {...registerSpeech("speechAgent", { required: "Agent is required" })}
                >
                  <option value="">-- Select Agent --</option>
                  {agents.map((agent) => (
                    <option key={agent.agent_id} value={agent.agent_id}>
                      {agent.agent_name}
                    </option>
                  ))}
                </select>
                {errorsSpeech.speechAgent && <div className="invalid-feedback d-block">{errorsSpeech.speechAgent.message}</div>}
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Description</label>
                <textarea
                  className={`form-control ${errorsSpeech.speechDescription ? 'is-invalid' : ''}`}
                  placeholder="Enter Description"
                  rows="3"
                  {...registerSpeech("speechDescription", { required: "Description is required" })}
                />
                {errorsSpeech.speechDescription && <div className="invalid-feedback d-block">{errorsSpeech.speechDescription.message}</div>}
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/ivr")}
              >
                <i className="bi bi-x-circle me-1"></i> Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSpeechCreate}
              >
                <i className="bi bi-save me-1"></i> {editMode ? 'Update IVR' : 'Save IVR'}
              </button>
            </div>
            </>
            }
          </div>
        </div>



  
      {/* SUCCESS MODAL */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #28a745, #20c997)",
            }}
          >
            <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2">Success</h5>

          {/* Message */}
          <p className="text-muted mb-4">{successMessage}</p>

          {/* Action */}
          <Button
            variant="success"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowSuccessModal(false)}
          >
            Done
          </Button>
        </Modal.Body>
      </Modal>


      {/* ERROR MODAL */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
            }}
          >
            <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2">Something went wrong</h5>

          {/* Message */}
          <p className="text-muted mb-4">{errorMessage}</p>

          {/* Action */}
          <Button
            variant="outline-danger"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowErrorModal(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>

    </div>
  );
}
